fx.ns("models", class Photo extends fx.Media {

	constructor(data) {
		super(data);

		this.isBlob = false;
		this._rate = 0;
	}

	get defaults() {
		return {
			light_url: "",
			url: "",
			used: 0,
			selected: false,
			initializing: false,
			faces: "",
			analysed: false,
			analysing: false,
			processing: false,
			people: 0,
			rate: 0,
			urls: {},
			pagesLabel: "",  // derived: labels of the pages the photo is placed on, as shown on the tile (e.g. "Couv., 2, 5..."); a string because fx wraps object/array defaults into a Model; never persisted (see propertiesNotStorable)
			pagesLabelFull: ""  // same, without the 3-number cap : what the tile's tooltip shows
		}
	}

	get propertiesNotStorable() {
		return ["accountid", "thumb", "urls", "effects", "url", "light_url", "width", "height", "id", "caption", "initializing", "selected", "pagesLabel", "pagesLabelFull", "orientation", "latitude", "longitude", "date_SQL", "date_unix", "date_taken_unix", "date_takenSQL", "analysing"];
	}

	get uploadParams() {
		return {
			accountid: this.accountid,
			id: this.id,
			original_filename: this.file ? this.file.name : "",
			creation_id: this.creation_id,
			orientation: this.orientation,
			latitude: this.latitude,
			longitude: this.longitude,
			date: this.date_SQL,
			date_unix: this.date_unix,
			date_taken: this.date_takenSQL,
			date_taken_unix: this.date_taken_unix,
			mediatype: this.mediatype,
			average_color: this.average_color,
			validated: this.validated,
			docid: this.docid,
			deleted: 0,
			guestid: this.guestid ? this.guestid : null,
			labels: this.labels
		}
	}

	get temporaryId() {
		return this.oldid ? this.oldid : (this.hash ? this.hash : this.id);
	}

	get globalRate() {
		return this.emotionalScore + this.artisticScore + this.technicalScore + this.facesPositions.length;
	}

	get emotionalScore() {
		if (this.facesPositions.length == 0)
			return 0;

		let photoArea = this.width * this.height;
		this.facesPositions.sort(function (a, b) { let aArea = (a.width * a.height), bArea = (b.width * b.height); return (aArea < bArea) ? 1 : ((aArea > bArea) ? -1 : 0); });

		let photoWidth = this.width, photoHeight = this.height;
		let numberSignificativeFaces = this.facesPositions.filter(function (face) {
			return ((face.width * photoWidth) * (face.height * photoHeight) * 100 / photoArea) > 0.5
		});

		let score = 0;
		for (let i = 0; i < this.facesPositions.length & i < 10; i++) {
			let emotionRate, face = this.facesPositions.getItemAt(i);
			switch (face.emotion) {
				case "angry":
					emotionRate = 0.2;
					break;

				case "disgust":
					emotionRate = 0.2;
					break;

				case "fear":
					emotionRate = 0.2;
					break;

				case "happy":
					emotionRate = 1;
					break;

				case "sad":
					emotionRate = 0.2;
					break;

				case "surprise":
					emotionRate = 1;
					break;

				case "neutral":
				default:
					emotionRate = 0;
					break;
			}

			//let percentage = (face.width * this.width) * (face.height * this.height) * 100 / photoArea; 
			let percentage = (face.width * face.height) * 100 / photoArea;

			// for pictures with face area higher that 1.5 %, we cap it. So a picture with a big smiling face is not absolutely more emotionnal than a picture with many small smily faces.
			score += (percentage > 0.5) ? Number(emotionRate * face.emotion_probability * Math.max(0.5, Math.min(percentage, 1.5))) * numberSignificativeFaces.length : 0.0;
		}

		return score.toFixed(2);
	}

	get artisticScore() {
		if (this.faces == null)
			return 0;

		return Utils.isNumber(this.faces.art_score) ? Number(this.faces.art_score) : 0;
	}

	get technicalScore() {
		if (this.faces == null)
			return 0;

		return Utils.isNumber(this.faces.tech_score) ? Number(this.faces.tech_score) : 0;
	}

	get colorfulness() {
		if (this.faces == null || !this.faces.hasOwnProperty("colorfulness"))
			return 100;

		return Utils.isNumber(this.faces.colorfulness) ? Number(this.faces.colorfulness) : 0;
	}

	get brightness() {
		if (this.faces == null || !this.faces.hasOwnProperty("brightness"))
			return 0;

		return Utils.isNumber(this.faces.brightness) ? Number(this.faces.brightness) : 0;
	}

	get needBrightness() {
		return this.brightness != 0 && ((this.brightness > 0 || this.brightness < 0.2) || this.colorfulness < 10);
	}

	get darkness() {
		return this.average_color ? Number(this.average_color) : 0;
	}

	get needColor() {
		return this.colorfulness < 20;
	}

	get tooDark() {
		return this.colorfulness < 2 || (this.colorfulness < 5.5 || this.brightness < 0.2);
	}

	get badQuality() {
		return (this.width < 250 || this.height < 250) ||
			((this.faces == null) ? false : (this.faces.tech_score < 4 || (this.faces.art_score < 4 || this.emotionalScore < 5 || !this.hasFaces) || this.tooDark || (this.texts > 0 || this.objects == 0)));
	}

	get texts() {
		return (this.faces == null || !this.faces.text) ? 0 : this.faces.text.length;
	}

	get objects() {
		return (this.faces == null || !this.faces.detected_objects) ? 0 : this.faces.detected_objects.length;
	}

	get uploaded() {
		return !this._upload || this._upload.uploaded
	}

	get progress() {
		if (this._upload) {
			if (this._upload.uploaded)
				return 100;
			else
				if (this._upload.uploading) {
					return this._upload.loaded * 100 / this._upload.size;
				}
				else
					return 0;
		}
		else
			return 0;
	}

	get mediatype()
	{ 
		return this.isHeic ? "heic" : 'photo'
	}

	get isHeic()
	{
		if (!this.file)
			return false;

		// the extractor read the head of the file : a .heic holding a jpeg is not a heic
		if (this.file.isHeic !== undefined)
			return this.file.isHeic;

		return this.file.name ? this.file.name.toLowerCase().endsWith(".heic") : false;
	}

	get isTemporary() {
		return Utils.isID(this.id);
	}

	get hasFaces() {
		let hasFaces = false;
		for (let i = 0; i < this.facesPositions.length; i++) {
			let face = this.facesPositions.getItemAt(i);

			if (isNaN(face.x) || isNaN(face.y) || isNaN(face.width) || isNaN(face.height))
				continue;

			hasFaces = true;
		}

		return hasFaces;

	}

	// only faces covering more than 2% of the picture (coordinates are normalized, so width * height is the area ratio)
	get facesPositions() {
		if (this.faces == null || this.faces.faces == null)
			return [];

		let faces = (this.faces.faces instanceof fx.ModelArray) ? this.faces.faces.toArray() : this.faces.faces;

		return faces.filter((face) => Number(face.width) * Number(face.height) > 0.0002);
	}

	get numberFaces() {
		return this.facesPositions.length;
	}

	get rectFaces() {
		if (!this.hasFaces)
			return null;

		if (!this._maxRect) {
			this._maxRect = {};

			for (let i = 0; i < this.facesPositions.length; i++) {
				let face = this.facesPositions.getItemAt(i);

				if (isNaN(face.x) || isNaN(face.y) || isNaN(face.width) || isNaN(face.height))
					continue;

				this._maxRect.x = this._maxRect.x == undefined || Number(face.x) < this._maxRect.x ? Number(face.x) : this._maxRect.x;
				this._maxRect.y = this._maxRect.y == undefined || Number(face.y) < this._maxRect.y ? Number(face.y) : this._maxRect.y;
				this._maxRect.right = this._maxRect.right == undefined || Number(face.x) + Number(face.width) > this._maxRect.right ? Number(face.x) + Number(face.width) : this._maxRect.right;
				this._maxRect.bottom = this._maxRect.bottom == undefined || Number(face.y) + Number(face.height) > this._maxRect.bottom ? Number(face.y) + Number(face.height) : this._maxRect.bottom;

				/*this._maxRect.x = Number( (this._maxRect.x === undefined) ? face.x : Math.min(Number(face.x), this._maxRect.x) );
				this._maxRect.y =  Number( (this._maxRect.y === undefined) ? face.y : Math.min(Number(face.y), this._maxRect.y) );
				this._maxRect.right = (this._maxRect.right === undefined) ? Number(face.x) + Number(face.width) :  Math.max(Number(face.x) + Number(face.width), this._maxRect.right);
				this._maxRect.bottom =  (this._maxRect.bottom === undefined) ? Number(face.y) + Number(face.height) : Math.max(Number(face.y) + Number(face.height), this._maxRect.bottom);*/
			}

			if (this._maxRect.right !== undefined || this._maxRect.x !== undefined || this._maxRect.bottom !== undefined || this._maxRect.y !== undefined) {
				this._maxRect.width = this._maxRect.right - this._maxRect.x;
				this._maxRect.height = this._maxRect.bottom - this._maxRect.y;
			}
		}

		return this._maxRect;
	}

	// select only big enougth faces (8% of total size)
	get importantRectFaces() {
		if (!this.hasFaces)
			return null;

		if (!this._importantRectFaces) {
			this._importantRectFaces = {};

			let sortedFaces = this.facesPositions.sort((a, b) => (a.width * a.height < b.width * b.height ? 1 : (a.width * a.height > b.width * b.height ? -1 : 0)));

			// we try to get only important faces (8% of total size)
			let faces = sortedFaces.filter((a) => a.width > 0.08 || a.height > 0.08);
			if (faces.length == 0) // if not, we get them all
				faces = sortedFaces;

			for (let i = 0; i < faces.length; i++) {
				let face = faces.getItemAt(i);


				if (isNaN(face.x) || isNaN(face.y) || isNaN(face.width) || isNaN(face.height))
					continue;

				this._importantRectFaces.x = this._importantRectFaces.x == undefined || Number(face.x) < this._importantRectFaces.x ? Number(face.x) : this._importantRectFaces.x;
				this._importantRectFaces.y = this._importantRectFaces.y == undefined || Number(face.y) < this._importantRectFaces.y ? Number(face.y) : this._importantRectFaces.y;
				this._importantRectFaces.right = this._importantRectFaces.right == undefined || Number(face.x) + Number(face.width) > this._importantRectFaces.right ? Number(face.x) + Number(face.width) : this._importantRectFaces.right;
				this._importantRectFaces.bottom = this._importantRectFaces.bottom == undefined || Number(face.y) + Number(face.height) > this._importantRectFaces.bottom ? Number(face.y) + Number(face.height) : this._importantRectFaces.bottom;
			}

			if (this._importantRectFaces.right !== undefined || this._importantRectFaces.x !== undefined || this._importantRectFaces.bottom !== undefined || this._importantRectFaces.y !== undefined) {
				this._importantRectFaces.width = this._importantRectFaces.right - this._importantRectFaces.x;
				this._importantRectFaces.height = this._importantRectFaces.bottom - this._importantRectFaces.y;
			}
		}

		return this._importantRectFaces;

	}

	get rectFacesQuality() {
		if (this.facesPositions.length == 0)
			return 0;

		let tolerance = (this.width / 3) * 0.5;

		let xMin = (this.width / 3) - tolerance,
			xMax = 2 * (this.width / 3) + tolerance;

		let yMin = (this.height / 3) - tolerance,
			yMax = 2 * (this.height / 3) + tolerance;

		let quality = 0;
		for (let i = 0; i < this.facesPositions.length; i++) {
			let face = this.facesPositions.getItemAt(i);

			// if face is in thirds
			if (face.x * this.width >= xMin || (face.x * this.width) + (face.width * this.width) <= xMax ||
				face.y * this.height >= yMin || (face.y * this.height) + (face.height * this.height) <= yMax)
				quality++;
			/*else
				quality -= 0.5;*/

		}

		return (quality / this.facesPositions.length);
	}


	getUrl(effect) {
		if (!effect || !this.urls[effect])
			return (fx.get("quality") == "light" /*|| this.loadLight*/) ? this.light_url : this.url;

		return (fx.get("quality") == "light" /*|| this.loadLight*/) ? this.urls[effect].medium : this.urls[effect].full;
	}

	getThumb(effect) {
		if (!effect || !this.urls[effect])
			return this.thumb;

		return this.urls[effect].thumb;
	}

	hasEffect(effect) {
		//return this.effects.contains(effect);
		return !!this.urls[effect];
	}

	/**
	 * fx.Media.load with one Image per version. The parent keeps a single _image for the media : two
	 * versions of a photo loading together (an erased version on the front cover, the original on
	 * the back) and the second replaced the first, whose load then never completed — its cache
	 * stayed "loading" for good and every later view of that version showed nothing.
	 */
	load(effect, light)
	{
		if (this.isLoading(effect))
		{
			this.trigger({ type : "loading", media : this });
			return;
		}

		if (this.getCache(effect) || (this.blob && !effect) || !this.getUrl(effect))
			return super.load(effect, light);

		this._loadLight = light;

		let key = effect || "";
		let image = new Image();
		image.crossOrigin = "anonymous";
		image._effect = effect;

		this._versionImages = this._versionImages || {};
		this._versionImages[key] = image;
		this._image = image;

		let listen = (value) => {
			let method = value ? "on" : "off";
			this[method](Image.LOAD_START, image._fxStart, image);
			this[method](Image.LOADED, image._fxComplete, image);
			this[method](Image.ERROR, image._fxError, image);
			this[method](Image.MEMORY_PROBLEM, image._fxError, image);
		};

		image._fxStart = () => this.trigger({ type : "start", media : this, effect : effect });

		image._fxComplete = () => {
			listen(false);
			delete this._versionImages[key];
			this.setCache(image.blob || image.src, effect, false, image.width, image.height);
			this.trigger({ type : "complete", media : this, effect : effect });
		};

		// only this version is dropped : the parent unloaded every version of the photo
		image._fxError = () => {
			listen(false);
			delete this._versionImages[key];
			this.setCache(null, effect);
			this.trigger({ type : "error", media : this, effect : effect });
		};

		listen(true);
		image.url(this.getUrl(effect));
		this.setCache(this.getUrl(effect), effect, true); // loading
	}

	unload()
	{
		for (let key in this._versionImages || {})
		{
			let image = this._versionImages[key];
			if (image && typeof image.destroy == "function")
				image.destroy();
		}

		this._versionImages = {};

		super.unload();
	}

	// a version's own size when the server gave it (effects written before it did have none)
	getImageWidth(effect) {
		if (!effect || !this.urls[effect] || !this.urls[effect].width)
			return this.width;

		return this.urls[effect].width;
	}

	getImageHeight(effect) {
		if (!effect || !this.urls[effect] || !this.urls[effect].height)
			return this.height;

		return this.urls[effect].height;
	}

	/**
	 * Faces found in the browser (curator.FaceFinder) : coordinates are already normalized (0..1)
	 * against the picture, the format facesPositions() reads. Memoized rects are reset so the stage
	 * recenters on the new faces.
	 */
	setNormalizedFaces(faces, extra)
	{
		let data = Object.assign({}, extra || {});

		data.faces = (faces || []).map((face) => ({
			x : Number(face.x),
			y : Number(face.y),
			width : Number(face.width),
			height : Number(face.height),
			emotion : "neutral",
			emotion_probability : 0,
			score : Number(face.score || 0)
		}));

		this.faces = data;
		this._maxRect = null;
		this._importantRectFaces = null;

		this.event("faces-updated");
	}

	setFaces(data) {
		let faces = [];
		for (let i = 0; i < data.faces.length; i++) {
			let face = data.faces.getItemAt(i);
			let x = face.coordinates ? Number(face.coordinates.getItemAt(1)) : Number(face.getItemAt(1));
			let y = face.coordinates ? Number(face.coordinates.getItemAt(0)) : Number(face.getItemAt(0));
			let width = face.coordinates ? Number(face.coordinates.getItemAt(2)) : Number(face.getItemAt(2));
			let height = face.coordinates ? Number(face.coordinates.getItemAt(3)) : Number(face.getItemAt(3));
			let emotion = face.emotion ? face.emotion : "neutral";
			let emotion_probability = face.emotion_probability ? Number(face.emotion_probability) : 0;

			faces.push({
				x: x / this.thumbWidth,
				y: y / this.thumbHeight,
				width: width / this.thumbWidth,
				height: height / this.thumbHeight,
				emotion: emotion,
				emotion_probability: emotion_probability
			});
		}

		data.faces = faces;

		this.faces = data;

		this.event("faces-updated");
	}


	calculateRate() {
		let rate = 0;

		if (this.tooDark)
			return;

		if (this.technicalScore > 5)
			rate += (Number(this.technicalScore) - 5) / 10;

		if (this.artisticScore > 5)
			rate += (Number(this.artisticScore) - 5) / 5;

		rate += (this.emotionalScore / 5);

		if (this.people == 0)
			rate += this.numberFaces * 0.2;
		else
			rate += this.people * 10;

		rate += (this.rectFacesQuality * 1);

		// experimental
		rate += this.brightness / 2;
		rate += this.colorfulness / 100;

		this.update({ rate: rate });
	}


	getAllRectFaces() {
		let faces = this.facesPositions;
		if (faces.length > 2) // if too many faces, let's get only the most important ones
		{
			faces.sort((a, b) => (a.width * a.height < b.width * b.height ? 1 : (a.width * a.height > b.width * b.height ? -1 : 0)));

			let finalFaces;
			for (let i = 10; i >= 3; i--) {
				let newfaces = faces.filter(function (face) {
					return (Number(face.width) * Number(face.height) * 100) > (i / 10); // let's filter most important  from 2% to 1%
				});

				if (newfaces.length > 0)
					finalFaces = newfaces;
			}
			if (finalFaces)
				faces = finalFaces;
		}

		let groups = faces.combinations();//this.combinations(this.facesPositions);
		let rects = [];

		for (let j = 0; j < groups.length; j++) {
			let group = groups[j];
			let maxRect = {};
			for (let i = 0; i < group.length; i++) {
				let face = group.getItemAt(i);

				maxRect.x = Number((maxRect.x === undefined) ? face.x : Math.min(Number(face.x), maxRect.x));
				maxRect.y = Number((maxRect.y === undefined) ? face.y : Math.min(Number(face.y), maxRect.y));
				maxRect.right = (maxRect.right === undefined) ? Number(face.x) + Number(face.width) : Math.max(Number(face.x) + Number(face.width), maxRect.right);
				maxRect.bottom = (maxRect.bottom === undefined) ? Number(face.y) + Number(face.height) : Math.max(Number(face.y) + Number(face.height), maxRect.bottom);
			}

			maxRect.width = maxRect.right - maxRect.x;
			maxRect.height = maxRect.bottom - maxRect.y;

			rects.push(maxRect)
		}

		return rects.sort((a, b) => (a.width * a.height < b.width * b.height ? -1 : (a.width * a.height > b.width * b.height ? 1 : 0)));

	}

	/*combinations(array) {
		return new Array(1 << array.length).fill().map(
		  (e1, i) => array.filter((e2, j) => i & 1 << j))
							  .filter((a) => a.length > 0)
							  .sort( (a, b) => (a.length < b.length ? -1 : (a.length > b.length ? 1 : 0)));
	  }*/


	delete(force) {
		if (force || !this.number > 0 /*|| this.file*/) // this.file mean photo was selected from a file, but not uploaded yet
		{
			// Photos are not deleted (it's done in backoffice, if no album uses a picture, this one is deleted after some time)
			this.update({ number: 0, deleted: 1 });
			this.unload();
		}
		else
			this.event("confirm-delete-photo", this);
	}



	select() {
		this.selected = !this.selected;
	}

	onUpdated(action) {
		if (action.impacts("url") || action.impacts("light_url") || action.impacts("urls")) {
			this.clean();
		}

		/*if (action.impacts("effects"))
		{
			for(let i = 0; i < this.effects.length; i++)
			{
				let effect = this.effects.getItemAt(i);
			    
				let cache = this.getCache(effect.name);
				if (cache)
				{
					cache.width = effect.width;
					cache.height = effect.height;
				}
			}
		}*/
	}


});